<a
                href="{{ url | async }}"
                target="_blank"
                class="fab fa-linkedin-in"></a>